import React, { useEffect, useRef, useState } from 'react';

import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';

import Button from 'components/Button';
import Mail from 'components/SvgComponents/icons/Mail';
import VerifyCode from 'components/VerifyCode';
import useCurrentUser from 'hooks/useCurrentUser';
import { useSendValidationEmailMutation } from 'redux/api/registration.api';
import globalMessages from 'translations/messages/global-messages';
import localStorageUser from 'utils/localStorageUser';

export const styles = theme => ({
  icon: {
    transition: 'transform 250ms',
  },
  iconOpen: {
    transform: 'rotate(180deg)',
  },
  '@media (prefers-reduced-motion: reduce)': {
    icon: {
      transition: 'transform 0ms',
    },
  },
  menuPaper: {
    borderRadius: 12,
    boxShadow: theme.shadows[2],
  },
  item: {
    display: 'flex',
    gap: '0.5rem',
  },
});

const VerifyEmailButton = ({ classes }) => {
  const intl = useIntl();
  const { email: currentUserEmail } = useCurrentUser();
  const [showDialog, setShowDialog] = useState(false);
  const [validationData, setValidationData] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const emailVerificationLink = localStorageUser.getEmailVerificationLink();
    if (emailVerificationLink) {
      setValidationData(emailVerificationLink);
      setShowDialog(true);
    }
    localStorageUser.setEmailVerificationLink(null);
    return () => setValidationData(null);
  }, []);
  const [sendValidationEmailMutation] = useSendValidationEmailMutation();

  const onVerifyClick = () => {
    if (!showDialog) {
      sendValidationEmailMutation({ email: currentUserEmail });
    }
    setShowDialog(!showDialog);
  };

  return (
    <>
      <Button ref={buttonRef} onClick={onVerifyClick} variant="outlined">
        <Mail
          height={16}
          width={16}
          className={classes.icon}
          title={intl.formatMessage(globalMessages.verify_your_email)}
        />

        {intl.formatMessage(globalMessages.verify_your_email)}
      </Button>
      <VerifyCode
        open={showDialog}
        validationCode={validationData?.code}
        onClose={() => setShowDialog(false)}
      />
    </>
  );
};

VerifyEmailButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
  withStyles(styles),
  reduxForm({
    destroyOnUnmount: true,
    enableReinitialize: true,
    form: 'enter-code',
  }),
)(VerifyEmailButton);
